"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var core_1 = require("stremio/core");
var Image_1 = __importDefault(require("stremio/components/Image"));
var LibItem_1 = __importDefault(require("stremio/components/LibItem"));
var EPG_1 = require("stremio/common/EPG");
var LiveTvContinueWatchingItem_less_1 = __importDefault(require("./LiveTvContinueWatchingItem.less"));
var getCurrentShow = function (shows, now) {
    var _a;
    return (_a = (Array.isArray(shows) ? shows : []).find(function (show) { return (0, EPG_1.getEpgProgress)(show, now) !== null; })) !== null && _a !== void 0 ? _a : null;
};
var LiveTvContinueWatchingItem = function (_a) {
    var _b;
    var _c;
    var className = _a.className, channel = _a.channel, deepLinks = _a.deepLinks, shows = _a.shows, notifications = _a.notifications;
    var core = (0, core_1.useCore)();
    var now = (0, EPG_1.useEpgNow)(true);
    var currentShow = react_1.default.useMemo(function () { return getCurrentShow(shows, now); }, [shows, now]);
    var programPoster = (0, EPG_1.getNonEmptyString)(currentShow === null || currentShow === void 0 ? void 0 : currentShow.thumbnail);
    var programName = (0, EPG_1.getNonEmptyString)(currentShow === null || currentShow === void 0 ? void 0 : currentShow.title);
    var hasProgram = Boolean(programPoster || programName);
    var channelName = (0, EPG_1.getNonEmptyString)(channel === null || channel === void 0 ? void 0 : channel.name);
    var channelLogo = (_c = (0, EPG_1.getNonEmptyString)(channel === null || channel === void 0 ? void 0 : channel.logo)) !== null && _c !== void 0 ? _c : (0, EPG_1.getNonEmptyString)(channel === null || channel === void 0 ? void 0 : channel.poster);
    var progress = hasProgram && currentShow !== null ? (0, EPG_1.getEpgProgress)(currentShow, now) : null;
    var posterSrc = hasProgram ? programPoster !== null && programPoster !== void 0 ? programPoster : (0, EPG_1.getNonEmptyString)(channel === null || channel === void 0 ? void 0 : channel.background) : channelLogo;
    var name = programName !== null && programName !== void 0 ? programName : channelName;
    var channelId = channel && channel.id;
    var onDismissClick = react_1.default.useCallback(function (event) {
        event.preventDefault();
        if (typeof channelId === 'string') {
            core.transport.dispatch({
                action: 'Ctx',
                args: { action: 'RewindLibraryItem', args: channelId },
            });
            core.transport.dispatch({
                action: 'Ctx',
                args: { action: 'DismissNotificationItem', args: channelId },
            });
        }
    }, [core, channelId]);
    var poster = react_1.default.useMemo(function () { return ({
        src: posterSrc,
        shape: 'landscape',
        changeCursor: true,
        overlay: hasProgram && (channelLogo || channelName) ?
            react_1.default.createElement("div", { className: LiveTvContinueWatchingItem_less_1.default['channel-badge'], title: channelName !== null && channelName !== void 0 ? channelName : undefined },
                channelLogo &&
                    react_1.default.createElement(Image_1.default, { src: channelLogo, alt: '', renderFallback: function () { return null; } }),
                channelName &&
                    react_1.default.createElement("span", null, channelName))
            :
                null,
    }); }, [posterSrc, hasProgram, channelLogo, channelName]);
    return (react_1.default.createElement(LibItem_1.default, { className: (0, classnames_1.default)(className, LiveTvContinueWatchingItem_less_1.default['live-item'], (_b = {}, _b[LiveTvContinueWatchingItem_less_1.default['channel-card']] = !hasProgram, _b)), _id: channel === null || channel === void 0 ? void 0 : channel.id, removable: true, type: channel === null || channel === void 0 ? void 0 : channel.type, name: name, poster: poster, progress: progress !== null && progress !== void 0 ? progress : 0, deepLinks: deepLinks, notifications: notifications, onDismissClick: onDismissClick }));
};
exports.default = LiveTvContinueWatchingItem;
